<template>
    <div class="c-input-select" :class="{disabled}">
        <input class="value" :class="{error}" type="text"
            :id="btnId" v-if="editable"
            v-model="getValue"
            @click.prevent="displayDropdown()"
            :tabindex="tabindex > -1 ? tabindex : false"
            v-on:blur="focusOut()"
        />
        <button v-if="!editable" :id="btnId" class="value" @click.prevent="toggleDropdown()">{{value}}</button>

        <button @click.prevent="toggleDropdown()" class="arrow" :class="{open : showDropdown}" :disabled="disabled"></button>

        <div class="options" v-if="showDropdown">
            <div class="option" v-for="option in options" :key="option" @click.prevent="setOption(option)">
                {{option}}
            </div>
            <div class="option" v-if="options.length == 0">
                <i>{{$t('generic.no_results')}}</i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"InputSelect",

    props: {
        value: {
            type: [Number, String],
            default: ""
        },
        options: {
            type: Array,
            default() {
                return [];
            }
        },
        editable : {
            type:Boolean,
            default : false
        },
        tabindex : {
            type:Number,
            default : -1
        },
        error: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showDropdown: false,
            btnId : "btn-input-select" + Math.random()
        };
    },

    computed: {
        getValue: {
            get: function() {
                return this.value;
            },
            set: function(value) {
                this.showDropdown = this.editable && value.trim() !== "";

                this.$emit("update:value", value);
            }
        }
    },

    methods: {
        toggleDropdown() {
            if (this.disabled) {
                return;
            }
            this.showDropdown = !this.showDropdown;
        },

        displayDropdown() {
            this.showDropdown = true;
        },

        setOption(option) {
            this.showDropdown = false;
            this.$emit("update:value", option);
        },

        focusOut() {
            setTimeout(() => {
                this.showDropdown = false;
            }, 500);
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-input-select {
        position: relative;
        width : 100%;
        text-align: center;
        margin-bottom: 1rem;
        $borderColor : #efefef;
        $optionHeight : 2rem;

        &.disabled {
            opacity: 0.5;
        }

        &.error {
            border: solid 2px red;
        }

        .value {
            @extend .inputfieldMixin;
            width: 100%;
            font-size: 1.25em;
        }

        .arrow {
            width: .8rem;
            height : 1rem;
            position: absolute;
            top: 1.1rem;
            right: 0.5rem;
            background-image : url("/img/select-arrow.svg");
            background-color : transparent;
            background-repeat: no-repeat;
            @extend .reset-btn;

            &.open {
                transform: scale(1, -1);
            }
        }

        .options {
            position: absolute;
            width : 90%;
            left : 5%;
            z-index: 55;
            overflow-y:scroll;
            max-height : #{5 * $optionHeight};
            margin-top: -0.9rem;
            box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.15);
            min-height: 2rem;
            background: white;
        }

        .option {
            background : white;
            border-left : solid 1px $borderColor;
            border-right : solid 1px $borderColor;
            border-bottom : solid 1px $borderColor;
            height: $optionHeight;
            line-height: $optionHeight;
            font-size: 1em;
            color: #A2A2A2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0 0.5rem;

            &:first-child {
                border-top : solid 1px $borderColor;
            }
        }
    }
</style>